import { Button, PageHeader, Tooltip, Upload, message } from 'antd';
import moment from 'moment';
import { useAppSelector } from '@/hooks/redux_hooks';
import { Link } from 'react-router-dom';
import { LoadingOutlined, LockOutlined, UserOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import ImgCrop from 'antd-img-crop';
import { beforeUploadImage, getBase64 } from '@/helpers/form_helper';
import { overrideUserAction } from '@/store/actions/sesi';
import { UploadChangeParam } from 'antd/lib/upload';
import { UploadFile } from 'antd/lib/upload/interface';

export default function HalamanDetailProfile() {
  const dispatch = useDispatch();
  const session = useAppSelector((state) => state.sesi.user);

  const [avatar, setAvatar] = useState<{
    loading: boolean;
    url: string;
    file?: any;
  }>({ loading: false, url: session.avatar });

  return (
    <>
      <PageHeader title="Profile" subTitle="Informasi mengenai akun anda" />
      <section className="px-5">
        <div className="rounded bg-white p-5 shadow grid grid-cols-12 gap-5 md:gap-10">
          <div className="col-span-12 md:col-span-3 lg:col-span-2">
            <ImgCrop rotate>
              <Upload
                data={{
                  role: 'ADMIN',
                }}
                listType="picture-card"
                showUploadList={false}
                withCredentials
                action={`${process.env.REACT_APP_BASE_URL_API}/profile/update-avatar`}
                beforeUpload={(file) => beforeUploadImage(file)}
                headers={{
                  Authorization: `Bearer ${Cookies.get(
                    process.env.REACT_APP_ACCESS_TOKEN,
                  )}`,
                  Accept: 'application/json',
                }}
                onChange={(info: UploadChangeParam<UploadFile<any>>) => {
                  if (info.file.status === 'uploading') {
                    setAvatar((old) => ({ ...old, loading: true }));
                    return;
                  }
                  if (info.file.status === 'error') {
                    message.error(
                      info.file?.response?.message || 'Error uploading image',
                    );

                    setAvatar((old) => ({ ...old, loading: false }));
                    return;
                  }
                  if (info.file.status === 'done') {
                    const res = info.file.response;
                    dispatch(overrideUserAction({ ...session, ...res }));

                    // Get this url from response in real world.
                    getBase64(info.file.originFileObj, (imageUrl) =>
                      setAvatar({
                        url: imageUrl,
                        loading: false,
                        file: info.file,
                      }),
                    );
                  }
                }}
              >
                {avatar.loading ? (
                  <LoadingOutlined />
                ) : (
                  <Tooltip placement="right" title="Klik untuk mengubah foto profile">
                    <img src={avatar.url} alt="avatar" className="w-full rounded" />
                  </Tooltip>
                )}
              </Upload>
            </ImgCrop>
          </div>
          <div className="col-span-12 md:col-span-9 lg:col-span-10">
            <div className="flex justify-between">
              <div className="flex-grow">
                <h1 className="font-bold text-xl md:text-2xl mb-0">{session?.nama}</h1>
              </div>
            </div>
            <hr className="my-5" />
            <div className="grid grid-cols-2">
              <div>
                <span className="text-gray-400">Email</span>
                <p>{session?.email}</p>
              </div>
            </div>
            <div className="grid grid-cols-2 mt-5">
              <div>
                <span>Akun dibuat pada</span>
                <p>{moment(session?.created_at).format('DD MMMM yyyy, HH:mm')}</p>
              </div>
              {session?.created_at !== session?.updated_at && (
                <div>
                  <span>Akun diperbaharui pada</span>
                  <p>{moment(session?.updated_at).format('DD MMMM yyyy, HH:mm')}</p>
                </div>
              )}
            </div>
            <hr className="my-7" />
            <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-5 mt-5">
              <Link to="perbaharui" className="text-green-700 font-bold">
                <Button icon={<UserOutlined />} className="w-full md:w-auto">
                  Perbaharui Informasi
                </Button>
              </Link>
              <Link to="password" className="text-yellow-700 font-bold">
                <Button icon={<LockOutlined />} className="w-full md:w-auto">
                  Ubah Password
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
